(ns app.components.checkbox.views
  (:require-macros)
  (:require [app.components.checkbox.styles :refer [checkbox-style
                                                    select-all-button]]
            [re-com.core :as re-com :refer [at checkbox]]))

(defn checkbox-component [{:keys [name ticked? onChange attr]}]
  [checkbox
   :src       (at)
   :label     name
   :model     ticked?
   :class (checkbox-style)
   :on-change onChange
   :attr attr
   :style {:background-color "red"}])



(defn select-all-checkbox-component [{:keys [selected? global-ticked? selected-all-ticked? all-assets assets-selected array-of-ticked]}]
  (fn []
    [:div {:class (select-all-button)}
     [checkbox
      :src       (at)
      :label     (if @selected-all-ticked? "Unselect all" "Select all")
      :model     selected-all-ticked?
      :class (checkbox-style)
      :label-style {:.hover {:backdrop-color "red"}}
      :on-change #(do (swap! selected-all-ticked? not)
                      (reset! array-of-ticked (mapv (fn [x] (update x :ticked (fn [e]
                                                                (if (false? %) false true)))) @array-of-ticked))

                      (if (= true @selected-all-ticked?)
                        (reset! assets-selected (mapv (fn [e] {:type (:type e) :id (:id e)
                                                               :name (:name e) :secondary-id (:secondary-id e)
                                                               :product-description (:product-description e)}) all-assets))
                        ((reset! assets-selected nil)
                         (reset! selected? false)
                         (reset! global-ticked? false)))
                      (swap! global-ticked? not))]]))